import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import user_tracker from '../../../usertracker'

export default {
  name: 'login',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoading: false,
      username: '',
      password: '',
      token:''
    }
  },
  computed: {},
  mounted() {
    if(apiUrl.isKavachLogin){
      this.checklogin();
    } else if (this.$route.params.token) {
        this.SSOLogin()
    } else {
      return false;
    }
  },
  methods: {
    SSOLogin() {
      this.isLoading = true;
      this.token = this.$route.params.token;
      axios.post(apiUrl.api_url_hubops + 'userauth/validusertoken', {
          'token': this.token
        },
        {
            'Strict-Transport-Security': `max-age=31536000; includeSubDomains; preload`,
            'X-Content-Type-Options': 'nosniff',
            'X-Frame-Options': 'sameorigin',
            'Content-Security-Policy': `default-src 'self'`
        })
        .then((response) => {
          this.isLoading = false
          if (response.data.ResultCode == 100) {
            if (response.data.ResponseData.accessurls.length > 0) {
              var date = new Date();
              var formatedDate = moment(date).format('DD-MM-YYYY');
              var formatedDateEncrypt = CryptoJS.AES.encrypt(JSON.stringify(formatedDate), "Key");
              var token = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.token), "Key");
              var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.accessurls), "Key");
              var userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.userdetails), "Key");
              window.localStorage.setItem('permissiondata', permissionEncrypt);
              window.localStorage.setItem('userdetail', userdetailEncrypt);
              window.localStorage.setItem('isLoggedIn', true);
              window.localStorage.setItem('userToken', token);
              window.localStorage.setItem('loginDate', formatedDateEncrypt);

              this.stateListData();

              var userdetailEncrypt = window.localStorage.getItem('userdetail')
              var permissionEncrypt = window.localStorage.getItem('permissiondata')
              var tokenEncrypt = window.localStorage.getItem('token')
              var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
              var permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
              var plaintext = bytes.toString(CryptoJS.enc.Utf8);
              var permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);

              var userdetail = JSON.parse(plaintext);
              var permissiondata = JSON.parse(permissiondataplaintext);
              var uasertype = userdetail[0].utype;
              // user_tracker.checkUserIP(userdetail[0],"login",this.$route.path);
              if (uasertype === null || uasertype === '') {
                this.$router.push('/dashboard');
                this.$alertify.success("Login Successful");
              } else {
                this.$router.push('/dashboard');
                this.$alertify.success("Login Successful");
              }

            } else {
              this.$alertify.error("No Access Granted, Contact Admin");
            }
          } else if (response.data.ResultCode == 302) {
            // this.$alertify.error(response.data.ReturnMessage);
            window.setTimeout(function(){
                window.location.href = response.data.RedirectURL;
            }, 2000);
          } else {
            this.$alertify.error(response.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false;
          console.log(error);
        })
        .catch((httpException) => {
          this.isLoading = false;
          console.error('exception is:::::::::', httpException)
        })
    },

    checklogin() {
      let auth = "authkey xB84JJ89Hd25";
      if(apiUrl.isKavachLogin){
        auth = `Bearer ${window.localStorage.getItem('access_token')}`;
      }else{
        this.input = ({
          "username": this.username,
          "password": this.password
        })
      }

      this.isLoading = true
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'userapp/auth',
          'data': this.input,
          headers: {
            'Authorization': auth,
            'Strict-Transport-Security': `max-age=31536000; includeSubDomains; preload`,
            'X-Content-Type-Options': 'nosniff',
            'X-Frame-Options': 'sameorigin',
            'Content-Security-Policy': `default-src 'self'`
          }
        })
        .then(response => {
          this.isLoading = false
          if (response.data.ResultCode == 100) {
            if (response.data.ResponseData.accessurls.length > 0) {
              var date = new Date();
              var formatedDate = moment(date).format('DD-MM-YYYY');
              var formatedDateEncrypt = CryptoJS.AES.encrypt(JSON.stringify(formatedDate), "Key");
              var token = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.token), "Key");
              var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.accessurls), "Key");
              var userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.userdetails), "Key");
              window.localStorage.setItem('permissiondata', permissionEncrypt);
              window.localStorage.setItem('userdetail', userdetailEncrypt);
              window.localStorage.setItem('isLoggedIn', true);
              window.localStorage.setItem('userToken', token);
              window.localStorage.setItem('loginDate', formatedDateEncrypt);
              window.localStorage.setItem('access_token', response.data.ResponseData.access_token);

              this.stateListData();

              var userdetailEncrypt = window.localStorage.getItem('userdetail')
              var permissionEncrypt = window.localStorage.getItem('permissiondata')
              var tokenEncrypt = window.localStorage.getItem('token')
              var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
              var permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
              var plaintext = bytes.toString(CryptoJS.enc.Utf8);
              var permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);

              var userdetail = JSON.parse(plaintext);
              var permissiondata = JSON.parse(permissiondataplaintext);
              var uasertype = userdetail[0].utype;
              // user_tracker.checkUserIP(userdetail[0],"login",this.$route.path);
              if (uasertype === null || uasertype === '') {
                this.$router.push('/dashboard');
                this.$alertify.success("Login Successful");
              } else {
                this.$router.push('/dashboard');
                this.$alertify.success("Login Successful");
              }

            } else {
              this.$alertify.error("No Access Granted, Contact Admin");
            }
          } else if (response.data.ResultCode == 302) {
            // this.$alertify.error(response.data.ReturnMessage);
            window.setTimeout(function(){
                window.location.href = response.data.RedirectURL;
            }, 2000);
          } else {
            this.$alertify.error(response.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false
          this.$alertify.error('error in api')
          console.error(error)
        })
    },

    userHubList(userid) {
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        this.input={
          'userid': userid
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getAllocatedHubsForUserForSingleLogin',
            'data': this.input,
            headers: {
              'Authorization': "authkey xB84JJ89Hd25",
              'Strict-Transport-Security': `max-age=31536000; includeSubDomains; preload`,
              'X-Content-Type-Options': 'nosniff',
              'X-Frame-Options': 'sameorigin',
              'Content-Security-Policy': `default-src 'self'`
            }
          })
        // axios.post(apiUrl.api_url_hubops + 'getAllocatedHubsForUserForSingleLogin', {
        //     'userid': userid
        //   })
          .then((result) => {
            this.isLoading = false;
            var userAssignedHubs = CryptoJS.AES.encrypt(JSON.stringify(result.data.ResponseData), "Key");
            window.localStorage.setItem('userAssignedHubs', userAssignedHubs);
            resolve(result)
          }, error => {
            this.isLoading = false;
            resolve(error);
          })
          .catch((httpException) => {
            this.isLoading = false;
            console.error('exception is:::::::::', httpException)
          })
      });

    },
    resetpassword(){
      let umurl= apiUrl.userauthentication_url.replace(/api/g,"")
      umurl = umurl.substring(0,umurl.length-2)
      window.location.href = umurl+'/#/resetpasswordwith2fa?redirecturl='+window.location.href;
    },

    stateListData() {
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'getStateList',
        headers: {
          'Authorization': "authkey xB84JJ89Hd25",
          'Strict-Transport-Security': `max-age=31536000; includeSubDomains; preload`,
          'X-Content-Type-Options': 'nosniff',
          'X-Frame-Options': 'sameorigin',
          'Content-Security-Policy': `default-src 'self'`
        }
      })
      .then((result) => {
        if(result.data.ResultCode == 100){
          window.localStorage.setItem('stateCodeList', result.data.ResponseData.StateCode);
        }
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      })
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
        else{
          this.checklogin();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js